// extracted by mini-css-extract-plugin
export default {"root":"Chips_root__6JB57","neutral":"Chips_neutral__jS8qQ","primary":"Chips_primary__w3YX+","danger":"Chips_danger__Gh1uF","orange":"Chips_orange__EWwyh"};